import { LinkFieldType } from '@portfolio/models'
import { fonts, styled } from '@portfolio/styles'
import { Link } from '../Link/Link'

type AnnouncementBarProps = {
  announcementBar: {
    title?: string
    ctaLabel?: string
    ctaLabelMobile?: string
    cta?: LinkFieldType
  }
  theme: 'transparent-dark' | 'transparent-light'
}

const AnnouncementBarWrapper = styled('div', {
  padding: '$12 $32',
  textAlign: 'center',
  display: 'grid',
  gridTemplateColumns: '1fr auto',
  alignItems: 'center',
  transition:
    'transform 0.3s ease-in-out, opacity 0.3s ease-in-out, background-color 0.3s ease-in-out',
  transform: 'translateY(0)',
  opacity: 1,
  variants: {
    theme: {
      'transparent-dark': {
        backgroundColor: '$gray50',
        color: '$darkThemeBackground',
      },
      'transparent-light': {
        backgroundColor: '$gray600',
        color: '$white',
      },
    },
  },
  defaultVariants: {
    theme: 'transparent-dark',
  },
})

const ContentWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '$24',
})

const Text = styled('p', {
  ...fonts.body05,
  display: 'none',
  variants: {
    theme: {
      'transparent-dark': {
        color: '$gray600',
      },
      'transparent-light': {
        color: '$white',
      },
    },
  },
  defaultVariants: {
    theme: 'transparent-dark',
  },

  '@lg': {
    display: 'block',
  },
})

const StyledLink = styled(Link, {
  ...fonts.body05,
  textUnderlineOffset: '.35em',
  variants: {
    theme: {
      'transparent-dark': {
        color: '$gray600',
      },
      'transparent-light': {
        color: '$white',
      },
    },
  },
  defaultVariants: {
    theme: 'transparent-dark',
  },
})

const DesktopCTALabel = styled('span', {
  display: 'none',

  '@lg': {
    display: 'block',
  },
})

const MobileCTALabel = styled('span', {
  display: 'block',

  '@lg': {
    display: 'none',
  },
})

export const AnnouncementBar = ({
  announcementBar,
  theme,
}: AnnouncementBarProps) => {
  return (
    <AnnouncementBarWrapper theme={theme}>
      <ContentWrapper>
        <Text theme={theme}>{announcementBar.title}</Text>
        {announcementBar.cta && announcementBar.ctaLabel && (
          <StyledLink
            appearance="textUnderline"
            {...announcementBar.cta}
            theme={theme}
          >
            <DesktopCTALabel>{announcementBar.ctaLabel}</DesktopCTALabel>
            <MobileCTALabel>{announcementBar.ctaLabelMobile}</MobileCTALabel>
          </StyledLink>
        )}
      </ContentWrapper>
    </AnnouncementBarWrapper>
  )
}
